const WIREX_CAPABILITIES = [
  ['Cards', 'Branded virtual cards, physical card path, Apple Pay, and Google Pay.'],
  ['Accounts', 'Named EUR, GBP, and USD virtual IBAN capability.'],
  ['Stablecoin spending', 'Fiat and stablecoin funding path for card usage.'],
  ['Payment rails', 'SEPA, SEPA Instant, ACH, and SWIFT support.'],
];

export default function WirexRailEconomics() {
  return (
    <section className="rounded-card border border-carbon-100 bg-white p-7">
      <div className="max-w-3xl">
        <p className="caption text-carbon-400">Strategic card and account rails</p>
        <h2 className="h3 mt-2">What the partnership unlocks.</h2>
        <p className="body-lg text-carbon-500 mt-4">
          Pulsar has a strategic relationship with Wirex to accelerate the launch of
          stablecoin-funded card accounts, virtual IBANs, and payment rails. This gives Pulsar a
          faster path to cardholders, transaction revenue, FX revenue, and premium account adoption
          without building the full issuing stack internally.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-7">
        {WIREX_CAPABILITIES.map(([title, body]) => (
          <div key={title} className="rounded-2xl border border-carbon-100 bg-carbon-25 p-5">
            <p className="label text-carbon-800">{title}</p>
            <p className="body-md text-carbon-500 mt-2">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
